import * as React from "react"
import GroupSection from "./Group-Section"
import GroupedTasksProvider from "./context/GroupedTasksProvider"

interface IContainerProps {}

const Container: React.FunctionComponent<IContainerProps> = () => {
  return (
    <>
      <GroupedTasksProvider>
        <GroupSection />
      </GroupedTasksProvider>
    </>
  )
}

export default Container
